import {
  BreakpointAction,
  ChoiceFunction,
  MucusTypesBreakpointOption,
  QuizDataInput,
} from '@naturalcycles/shared'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst'
import { addPageToFlowAfterCurrent, removePageFromFlow } from '@src/app/util/quiz.util'
import { DefaultQuizSection } from '@src/typings/quiz.enum'

const yesTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = (flow, _data) => {
  return addPageToFlowAfterCurrent(
    flow,
    DefaultQuizSection.cycleChanges,
    QuizPage.cycleChangesMucusTypes,
    QuizPage.cycleChangesSexDriveAndMucusInfo,
  )
}

const noTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = (flow, data) => {
  if (data?.sexDriveChanges) return flow

  return removePageFromFlow(
    flow,
    DefaultQuizSection.cycleChanges,
    QuizPage.cycleChangesSexDriveAndMucusInfo,
  )
}

export const cycleChangesMucusTypesBreakpoint: BreakpointAction<
  MucusTypesBreakpointOption,
  QuizPage,
  QuizDataInput
> = {
  [MucusTypesBreakpointOption.sticky]: yesTransformFunction,
  [MucusTypesBreakpointOption.creamy]: yesTransformFunction,
  [MucusTypesBreakpointOption.light]: yesTransformFunction,
  [MucusTypesBreakpointOption.medium]: yesTransformFunction,
  [MucusTypesBreakpointOption.heavy]: yesTransformFunction,
  [MucusTypesBreakpointOption.eggWhite]: yesTransformFunction,
  [MucusTypesBreakpointOption.watery]: yesTransformFunction,
  [MucusTypesBreakpointOption.skip]: noTransformFunction,
}
